import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-split-bill-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    TableModule,
    CheckboxModule,
    DropdownModule,
    InputNumberModule,
  ],
  templateUrl: './split-bill-dialog.component.html',
  styleUrl: './split-bill-dialog.component.scss',
})
export class SplitBillDialogComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() products: any[] = [];
  @Input() roundedTotal: number = 0;

  @Output() splitApplied: EventEmitter<{
    splitMethod: string;
    numberOfPeople: number;
    selectedProducts: any[];
  }> = new EventEmitter();
  @Output() dialogClosed: EventEmitter<void> = new EventEmitter<void>();

  readonly splitMethodOptions = [
    { label: 'By item', value: 'item' },
    { label: 'Evenly', value: 'evenly' },
  ];

  splitMethod: string = 'item';
  numberOfPeople: number = 1;

  onVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
    if (!value) {
      this.dialogClosed.emit();
    }
  }

  onSplitMethodChange(): void {
    // Handle split method change if needed
  }

  applySplit(): void {
    if (this.splitMethod === 'item') {
      const selectedProducts = this.products.filter(
        (product) => product?.selected,
      );
      this.splitApplied.emit({
        splitMethod: 'item',
        numberOfPeople: this.numberOfPeople,
        selectedProducts,
      });
    } else if (this.splitMethod === 'evenly') {
      const splitAmount = this.roundedTotal / (this.numberOfPeople || 1);
      console.log(
        `Split evenly among ${this.numberOfPeople} people: ${splitAmount}`,
      );
      this.splitApplied.emit({
        splitMethod: 'evenly',
        numberOfPeople: this.numberOfPeople,
        selectedProducts: [],
      });
    }
    this.hideSplitBillDialog();
  }

  hideSplitBillDialog(): void {
    this.visible = false;
    this.onVisibleChange(false);
  }
}
